// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  ENV_MODE: 'development',
  APP_VERSION: '1.0.0',
  API_BASE_URL: 'https://ai-platform-staging.paymobsolutions.com',
};
